import React, { useState } from "react";
import { Button, Icon } from "@mui/material";
import Input from "@mostrans/web-components/components/base/Input";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Select from "@mostrans/web-components/components/base/Select";
import {
  useGetMasterDivision,
  useGetMasterKota,
} from "../../../../shared/hooks/useGetMasterData";
import FormAddRequirements from "./FormAddRequirements";
import { useRecoilState, useResetRecoilState } from "recoil";
import {
  valueInputOpportunity,
  valueInputJobRequirementAtoms,
} from "../../../../shared/atoms/getValueInputAtoms";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function FormCreate(props) {
  const { errInput, errJobReqMsg } = props;
  const [listMasterKota] = useGetMasterKota();
  const [listDivision] = useGetMasterDivision();
  const [visibleRequirements, setVisibleRequirements] = useState(false);
  const [inputOpportunity, setInputOpportunity] = useRecoilState(
    valueInputOpportunity
  );
  const setClearValueRequirement = useResetRecoilState(
    valueInputJobRequirementAtoms
  );

  const optionsKota = listMasterKota.map(function (kota) {
    return { value: kota.id, label: kota.nama };
  });

  const optionsDivision = listDivision.map(function (divisi) {
    return { value: divisi.id, label: divisi.division };
  });

  const optionsJobLevel = [
    { value: "Entry Level", label: "Entry Level" },
    { value: "Middle Level", label: "Middle Level" },
    { value: "Senior Level", label: "Senior Level" },
  ];


  const handleVisibleRequirement = () => {
    setVisibleRequirements((s) => !s);
    setClearValueRequirement();
  };


  return (
    <React.Fragment>
      <div className="form-row mb-1">
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Title is required</p>}
            isError={errInput && !inputOpportunity.title}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Jobs Name
            </label>
            <Input
              type="text"
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  title: e.target.value,
                })
              }
              placeholder="Input Job Title"
            />
          </FormGroup>
        </div>
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={
              <p style={{ fontSize: 13 }}>Base Location is required</p>
            }
            isError={errInput && !inputOpportunity.location_id}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Base Location
            </label>
            <Select
              options={optionsKota}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  location_id: e.value,
                })
              }
            />
          </FormGroup>
        </div>
      </div>

      <div className="form-row mb-1">
        <div className="col-md-6">
          {" "}
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Division is required</p>}
            isError={errInput && !inputOpportunity.division_id}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Division
            </label>
            <Select
              options={optionsDivision}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  division_id: e.value,
                })
              }
            />
          </FormGroup>
        </div>
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Job Level is required</p>}
            isError={errInput && !inputOpportunity.job_level}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Job Level
            </label>
            <Select
              options={optionsJobLevel}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  job_level: e.value,
                })
              }
            />
          </FormGroup>{" "}
        </div>
      </div>
      <div className="form-row mb-1">
        <div className="col-md-12">
          {" "}
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={
              <p style={{ fontSize: 13 }}>Description is required</p>
            }
            isError={errInput && !inputOpportunity.description}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Description
            </label>
            <ReactQuill
              theme="snow"
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  description: e,
                })
              }
            />
          </FormGroup>
        </div>
      </div>

      {/* <div className="form-row mb-1">
        <div className="col-md-6">
          <label htmlFor="" style={{ fontSize: 12 }}>
            Job Description
          </label>
        </div>
      </div> */}

      {/* {visibleJobDesc ? <FormAddJobDesc /> : null} */}
      {/* 
      <div className="form-row mb-1">
        <div className="col-md-6">
          {!visibleJobDesc ? (
            <Button
              variant="outlined"
              onClick={() => handleVisibleJobDesc()}
              color="primary"
            >
              Add
              <Icon sx={{ ml: 1 }}>add</Icon>
            </Button>
          ) : (
            <Button
              variant="outlined"
              onClick={() => handleVisibleJobDesc()}
              color="error"
            >
              Clear
              <Icon sx={{ ml: 1 }}>remove_circle_outline</Icon>
            </Button>
          )}
        </div>
      </div> */}

      <div className="form-row mb-1">
        <div className="col-md-6">
          <label htmlFor="" style={{ fontSize: 12 }}>
            Job Requirement
          </label>
          <p className="text-danger" style={{ fontSize: 13 }}>
            {errJobReqMsg}
          </p>
        </div>
      </div>

      {visibleRequirements ? <FormAddRequirements /> : null}
      <div className="form-row mb-1">
        <div className="col-md-6">
          {!visibleRequirements ? (
            <Button
              variant="outlined"
              onClick={() => handleVisibleRequirement()}
              color="primary"
            >
              Add
              <Icon sx={{ ml: 1 }}>add</Icon>
            </Button>
          ) : (
            <Button
              variant="outlined"
              onClick={() => handleVisibleRequirement()}
              color="error"
            >
              Clear
              <Icon sx={{ ml: 1 }}>remove_circle_outline</Icon>
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default FormCreate;
